const icon = (name) => <img src={`/assets/icons/navbar/${name}.png`} sx={{ width: 2, height: 2 }} />;

const navConfig = [
  {
    title: 'Pregled',
    path: '/dashboard/app',
    icon: icon('dashboard'),
  },
  {
    title: 'Evidencija korisnika',
    path: '/dashboard/HuntersReportAll',
    icon: icon('users'),
  },
  {
    title: 'Evidencija uređaja',
    path: '/dashboard/DogsReportAll',
    icon: icon('dogs'),
  },
  {
    title: 'Dijeljeni uređaji',
    path: '/dashboard/SharedDevices',
    icon: icon('sh'),
  },
  {
    title: 'Nedodjeljeni uređaji',
    path: '/dashboard/UnassociatedDevices',
    icon: icon('un'),
  },
  {
    title: 'Online',
    path: '/dashboard/OnlineDevices',
    icon: icon('on'),
  },
  {
    title: 'Nevažeći vaučeri',
    path: '/dashboard/UnpaidDevices',
    icon: icon('nomoney'),
  },
   {
    title: 'Mapa',
    path: '/dashboard/Mapa',
    icon: icon('map'),
  },
  {
    title: 'Mapa Live',
    path: '/dashboard/MapaLive',
    icon: icon('map'),
  },
  {
    title: 'Mapa Live Multiple',
    path: '/dashboard/MapaLiveMultiple',
    icon: icon('map'),
  },
  {
    title: 'Mapa Live Multiple Analyse',
    path: '/dashboard/MapaLiveMultipleAnalyse',
    icon: icon('map'),
  },
  {
    title: 'Uplate',
    path: '/dashboard/Bills',
    icon: icon('payments'),
  },
];

export default navConfig;
